<script setup lang="ts">
import type { MentionNodeViewProps } from "./types";
import { NodeViewWrapper } from "@tiptap/vue-3";
import { useAuth } from "ls/features/user/useAuth";
import { computed } from "vue";
import { useSelectionIntersectsNodeView } from "../useSelectionIntersectsNodeView";
import { useMentionedUsersProfiles } from "./context";

const props = defineProps<MentionNodeViewProps>();
const selectionIntersects = useSelectionIntersectsNodeView(props, { allowEmpty: false });

const selectedOrIntersects = computed(() => {
  return props.selected || selectionIntersects.value;
});

const { user } = useAuth();

const { profilesMap } = useMentionedUsersProfiles();

const name = computed(() => {
  const fallback = props.node.attrs.label;

  if (!profilesMap.value) return fallback;
  const profile = profilesMap.value.get(props.node.attrs.id);

  if (!profile) return fallback;
  return profile.nickname || profile.email || fallback;
});
</script>

<template>
  <!-- eslint-disable vue/multiline-html-element-content-newline -->
  <NodeViewWrapper
    as="span"
    :data-type="node.type.name"
    class="cursor-default rounded-md border px-1 py-0.5 font-normal whitespace-nowrap text-blue-600 select-none"
    :class="{
      'bg-blue-50': node.attrs.id !== user?.userId,
      'bg-amber-100': node.attrs.id === user?.userId,
      'border-transparent': !selectedOrIntersects,
      'ring-1 ring-blue-600': selectedOrIntersects,
    }"
  >@{{ name }}</NodeViewWrapper>
</template>
